export default "__VITE_ASSET__cbf4247e__"